import { PaymentMethod } from '../../interfaces';
import { PAYMENT_METHOD_ID } from '../payment-method-id';

export const GOOGLE_PAY: PaymentMethod = {
    id: PAYMENT_METHOD_ID.GooglePay,
    name: 'googlepay',
    tokenRequired: true
};
